import api from '../../../api';

// Get all modules
export const getModules = async () => {
  try {
    const response = await api.get('/permissions/modules');
    return response.data;
  } catch (error) {
    console.error('Error fetching modules:', error);
    throw error;
  }
};

// Get all capabilities (optionally filtered by module)
export const getCapabilities = async (moduleId = null) => {
  try {
    const url = moduleId ? `/permissions/capabilities?moduleId=${moduleId}` : '/permissions/capabilities';
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching capabilities:', error);
    throw error;
  }
};

// Create new capability
export const createCapability = async (capabilityData) => {
  try {
    console.log('=== DEBUG: Create Capability ===');
    console.log('Capability Data:', capabilityData);
    
    const response = await api.post('/permissions/capabilities', capabilityData);
    
    console.log('=== DEBUG: Create Response ===');
    console.log('Response Status:', response.status);
    console.log('Response Data:', response.data);
    console.log('=== END DEBUG ===');
    
    return response.data;
  } catch (error) {
    console.error('Error creating capability:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

// Update capability
export const updateCapability = async (capabilityId, capabilityData) => {
  try {
    console.log('=== DEBUG: Update Capability ===');
    console.log('Capability ID:', capabilityId);
    console.log('Capability Data:', capabilityData);
    
    const response = await api.put(`/permissions/capabilities/${capabilityId}`, capabilityData);
    
    console.log('=== DEBUG: Update Response ===');
    console.log('Response Status:', response.status);
    console.log('Response Data:', response.data);
    console.log('=== END DEBUG ===');
    
    return response.data;
  } catch (error) {
    console.error('Error updating capability:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

// Delete capability
export const deleteCapability = async (capabilityId) => {
  try {
    console.log('=== DEBUG: Delete Capability ===');
    console.log('Capability ID:', capabilityId);
    
    const response = await api.delete(`/permissions/capabilities/${capabilityId}`);
    
    console.log('=== DEBUG: Delete Response ===');
    console.log('Response Status:', response.status);
    console.log('Response Data:', response.data);
    console.log('=== END DEBUG ===');
    
    return response.data;
  } catch (error) {
    console.error('Error deleting capability:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};
